import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem('admin-theme');
        return saved || 'light';
    });

    useEffect(() => {
        const root = window.document.documentElement;
        root.classList.remove('light', 'dark');
        root.classList.add(theme);
        localStorage.setItem('admin-theme', theme);

        // Set CSS variables for toast
        if (theme === 'dark') {
            root.style.setProperty('--toast-bg', '#0F0F0F');
            root.style.setProperty('--toast-color', '#FFFFFF');
        } else {
            root.style.setProperty('--toast-bg', '#FFFFFF');
            root.style.setProperty('--toast-color', '#000000');
        }
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
}

